"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialValues = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _color = _interopRequireDefault(require("color"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdColorPicker = require("cccisd-color-picker");
var _cccisdFormik = require("cccisd-formik");
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _modalOn = _interopRequireDefault(require("./modalOn.png"));
var _modalOff = _interopRequireDefault(require("./modalOff.png"));
var _aspectRatioOptions = _interopRequireDefault(require("../../../../navigations/withModules/Settings/aspectRatioOptions.js"));
var _style = _interopRequireDefault(require("./style.css"));
var _index = require("../index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var initialValues = exports.initialValues = {
  mustTakeInOrder: true,
  showLastVisited: false,
  showLessonNum: true,
  showProgressBubbleNum: true,
  showLessonsInModal: false,
  suppressOnComplete: true,
  aspectRatio: '',
  highlighting: '',
  requiredHighlightColor: '#c5422b',
  optionalHighlightColor: '#6f6f6f',
  baseColor: '#176987',
  buttonColors: {
    start: '#176987',
    resume: '#a95a14',
    replay: '#636466'
  },
  progressBubbleColors: {
    resume: 'primaryColor',
    replay: '#43a047'
  },
  labelForLessonEn: 'Lesson',
  labelForModuleEn: 'Module',
  labelForLessonEs: 'Leccion',
  labelForModuleEs: 'Módulo'
};
var General = function General(_ref) {
  var assignmentData = _ref.assignmentData,
    formikBag = _ref.formikBag;
  var buildLanguages = (0, _get2["default"])(assignmentData, 'settings.buildLanguages', []) || [];
  var isEnglish = buildLanguages.includes('en');
  var isSpanish = buildLanguages.includes('es');
  var values = formikBag.values;
  var prefix = values.currentPrefix;
  var currValues = (0, _get2["default"])(values, prefix, {});
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: prefix + '.mustTakeInOrder',
    component: _cccisdFormik.CccisdToggle,
    label: "User must take surveys in order"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: prefix + '.suppressOnComplete',
    component: _cccisdFormik.CccisdToggle,
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Suppress completion message from Data Collection Wave", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "When a user completes all required lessons in all modules, do you want the Data Colleciton Wave completion message to show?"), /*#__PURE__*/_react["default"].createElement("p", null, "Toggling this setting to ", /*#__PURE__*/_react["default"].createElement("b", null, "NO"), " allows the message to show."), /*#__PURE__*/_react["default"].createElement("p", null, "Toggling this setting to ", /*#__PURE__*/_react["default"].createElement("b", null, "YES"), " suppresses the message and kicks users right back to the dashboard upon completing the final survey."))
    }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: prefix + '.showLastVisited',
    component: _cccisdFormik.CccisdToggle,
    label: "Show Last Visited Date"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: prefix + '.showLessonNum',
    component: _cccisdFormik.CccisdToggle,
    label: "Show Lesson Numbers"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: prefix + '.showProgressBubbleNum',
    component: _cccisdFormik.CccisdToggle,
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Show Progress Bubble Numbers", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "Show each lesson number within the progress bubble on the course player."
    }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: prefix + '.showLessonsInModal',
    component: _cccisdFormik.CccisdToggle,
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Show Lessons in Modal", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].lessonInModalTooltip
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h6", null, "YES"), /*#__PURE__*/_react["default"].createElement("img", {
        src: _modalOn["default"],
        alt: "modal on"
      })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h6", null, "NO"), /*#__PURE__*/_react["default"].createElement("img", {
        src: _modalOff["default"],
        alt: "modal off"
      })))
    }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col col-12 col-md-6"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: prefix + '.labelForLessonEn',
    component: _cccisdFormik.CccisdInput,
    label: 'Label For "Lesson" (English)',
    disabled: !isEnglish
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col col-12 col-md-6"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: prefix + '.labelForLessonEs',
    component: _cccisdFormik.CccisdInput,
    label: 'Label For "Lesson" (Spanish)',
    disabled: !isSpanish
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col col-12 col-md-6"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: prefix + '.labelForModuleEn',
    component: _cccisdFormik.CccisdInput,
    label: 'Label For "Module" (English)',
    disabled: !isEnglish
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col col-12 col-md-6"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: prefix + '.labelForModuleEs',
    component: _cccisdFormik.CccisdInput,
    label: 'Label For "Module" (Spanish)',
    disabled: !isSpanish
  }))), currValues.showLessonsInModal && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: prefix + '.aspectRatio',
    component: function component(fieldProps) {
      // avoids React warning for passing `value` prop of null
      if (!fieldProps.field.value) {
        fieldProps.field.value = '';
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdSelect, _extends({}, (0, _index.forceTouchedOnChange)(fieldProps), {
        label: "Force aspect ratio",
        options: _aspectRatioOptions["default"],
        style: {
          width: 'auto'
        }
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: prefix + '.highlighting'
  }, function (fieldProps) {
    // avoids React warning for passing `value` prop of null
    if (!fieldProps.field.value) {
      fieldProps.field.value = '';
    }
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdSelect, _extends({}, (0, _index.forceTouchedOnChange)(fieldProps), {
      style: {
        width: 'auto'
      },
      label: /*#__PURE__*/_react["default"].createElement("span", null, "Highlighting", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("ul", {
          className: _style["default"].highlightOptions
        }, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("b", null, "Required:"), " Highlights all lessons that have the \"Required\" setting toggled ON. Modules will be highlighted if they contain one at least one required survey."), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("b", null, "Optional:"), " Highlights all lessons that have the \"Required\" setting toggled OFF. Modules will be highlighted if they contain exclusively non-required surveys."))),
        placement: "top"
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null))),
      options: [{
        value: '',
        label: '-- None --'
      }, {
        value: 'required',
        label: 'Required'
      }, {
        value: 'optional',
        label: 'Optional'
      }]
    }));
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: prefix + '.baseColor',
    label: "Base Color"
  }, function (fieldProps) {
    var colorValue = (0, _color["default"])((0, _cccisdColorPicker.getColor)(fieldProps.field.value));
    var contrast = colorValue.contrast((0, _color["default"])('#FBFBFB'));
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label"
    }, "Base Color"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdColorPicker, fieldProps), contrast <= 4.4 && /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-warning"
    }, "Note: The selected color may be too light. You may wish to choose a darker color for greater contrast."));
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: prefix + '.buttonColors.start',
    component: _cccisdFormik.CccisdColorPicker,
    label: "Start Button"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: prefix + '.buttonColors.resume',
    component: _cccisdFormik.CccisdColorPicker,
    label: "Resume Button"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: prefix + '.buttonColors.replay',
    component: _cccisdFormik.CccisdColorPicker,
    label: "Replay Button"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: prefix + '.progressBubbleColors.resume',
    component: _cccisdFormik.CccisdColorPicker,
    label: "Progress Bubble - Resume"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: prefix + '.progressBubbleColors.replay',
    component: _cccisdFormik.CccisdColorPicker,
    label: "Progress Bubble - Complete"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: prefix + '.requiredHighlightColor',
    component: _cccisdFormik.CccisdColorPicker,
    label: "Required Highlight Color"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: prefix + '.optionalHighlightColor',
    component: _cccisdFormik.CccisdColorPicker,
    label: "Optional Highlight Color"
  }));
};
var _default = exports["default"] = General;